module.exports = __webpack_public_path__ + "img/pro-face-photo2.78f68b64.jpg";